import { Toaster } from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./pages/Home";
import AiAgent from "./pages/AiAgent";
import Landing from "./pages/Landing";
import VoiceMail from "./pages/VoiceMail";
import ErrorLogs from "./pages/ErrorLogs";
import InvitePage from "./pages/InvitePage";
import TeamMembers from "./pages/TeamMembers";
import RequestPage from "./pages/NumberAccess";
import Settings from "./pages/Settings/Settings";
import LoginScreen from "./pages/Auth/LoginScreen";
import CallDashboard from "./pages/CallDashboard";
import CompanyProfile from "./pages/CompanyProfile";
import UserExtensions from "./pages/UserExtensions";
import SignupScreen from "./pages/Auth/SignupScreen";
import ProfilePage from "./pages/Settings/ProfilePage";
import PageNotFound from "./pages/Errors/PageNotFound";
import ExtensionAllocation from "./pages/ExtensionAllocation";
import UnauthorizedPage from "./pages/Errors/UnauthorizedPage";

// VAPI Feature Pages
import VoiceModels from "./pages/VAPI/VoiceModels";
import Transcriber from "./pages/VAPI/Transcriber";
import Tools from "./pages/VAPI/Tools";
import CallAnalysis from "./pages/VAPI/CallAnalysis";
import PrivacySettings from "./pages/VAPI/PrivacySettings";
import Widget from "./pages/VAPI/Widget";
import PhoneNumbers from "./pages/VAPI/PhoneNumbers";
import ApiKeys from "./pages/VAPI/ApiKeys";
import Workflows from "./pages/VAPI/Workflows";
import OutboundCalls from "./pages/VAPI/OutboundCalls";
import Files from "./pages/VAPI/Files";
import Integrations from "./pages/VAPI/Integrations";
import Logs from "./pages/VAPI/Logs";
import Billing from "./pages/VAPI/Billing";
import ToastTheme from "./themes/ToastTheme";
import CallScreen from "./components/Dialpad/CallScreen";
import PrivateRoute from "./auth/PrivateRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import ModalManager from "./components/Modals/VAPI/ModalManager";

import "./App.css";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import Demo from "./pages/Demo";
import TryoutScreen from "./pages/Auth/TryoutScreen";
import ContactCaller from "./components/ContactsListing/Contact";
import AssistantsList from "./components/Assistants/AssistantsList";
// import DemoALL from "./components/DemoALL";
import AssistantConfiguration from "./components/Assistants/AssistantConfiguration";
import VoiceLibrary from "./components/VoiceLibrary/VoiceLibrary";
import LLMConfigsList from "./components/Admin/LLMConfigs/LLMConfigsList";
import VoiceConfigsList from "./components/Admin/VoiceConfigs/VoiceConfigsList";
import TranscriberConfigsList from "./components/Admin/TranscriberConfigs/TranscriberConfigsList";
import AnalysisConfigsList from "./components/Admin/AnalysisConfigs/AnalysisConfigsList";
import Payment from "./components/Payment/Payment";
import PaymentHistory from "./components/Payment/PaymentHistory";
import ToolsList from "./components/Admin/ToolConfigs/ToolsList";
import AdminSettings from "./components/Admin/Settings/Settings";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute element={<DashboardLayout />} roles={["2", "3"]} />,
    errorElement: <PageNotFound />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "call",
        element: <CallDashboard />,
      },
      {
        path: "contact-us",
        element: <Home />,
      },
      {
        path: "extensions-allocation",
        element: <PrivateRoute element={<ExtensionAllocation />} roles={["2"]} />,
      },
      {
        path: "voice-mail",
        element: <PrivateRoute element={<VoiceMail />} roles={["2", "3"]} />,
      },
      {
        path: "extensions",
        element: <PrivateRoute element={<UserExtensions />} roles={["3"]} />,
      },
      {
        path: "requests",
        element: <PrivateRoute element={<RequestPage />} roles={["2"]} />,
      },
      {
        path: "invites",
        element: <PrivateRoute element={<InvitePage />} roles={["2"]} />,
      },
      {
        path: "users",
        element: <PrivateRoute element={<TeamMembers />} roles={["2"]} />,
      },
      {
        path: "ai-agent",
        element: <PrivateRoute element={<AiAgent />} roles={["2"]} />,
      },
      {
        path: "error-logs",
        element: <PrivateRoute element={<ErrorLogs />} roles={["2"]} />,
      },
      {
        path: "settings",
        element: <PrivateRoute element={<Settings />} roles={["2", "3"]} />,
      },
      {
        path: "setting-page",
        element: <Settings />,
      },
      {
        path: "company-profile",
        element: <CompanyProfile />,
      },
      {
        path: "/demo",
        element: <PrivateRoute element={<Demo />} roles={["3"]} />,
      },
      {
        path: "contact-list",
        element: <ContactCaller />,
      },
      // VAPI Feature Routes
      {
        path: "/assistants",
        element: <PrivateRoute element={<AssistantsList  roles={["2"]}/>} />,
      },

     {
        path: "/assistants/create",
        element: <PrivateRoute element={<AssistantConfiguration />} roles={["2"]} />,
      },
      {
        path: "/assistants/:id/edit",
        element: <PrivateRoute element={<AssistantConfiguration />} roles={["2"]} />,
      },
      {
        path: "vapi-voice-models",
        element: <PrivateRoute element={<VoiceModels />} roles={["2"]} />,
      },
      {
        path: "vapi-transcriber",
        element: <PrivateRoute element={<Transcriber />} roles={["2"]} />,
      },
      {
        path: "vapi-tools",
        element: <PrivateRoute element={<Tools />} roles={["2"]} />,
      },
      {
        path: "vapi-call-analysis",
        element: <PrivateRoute element={<CallAnalysis />} roles={["2"]} />,
      },
      {
        path: "vapi-privacy-settings",
        element: <PrivateRoute element={<PrivacySettings />} roles={["2"]} />,
      },
      {
        path: "vapi-widget",
        element: <PrivateRoute element={<Widget />} roles={["2"]} />,
      },
      {
        path: "vapi-phone-numbers",
        element: <PrivateRoute element={<PhoneNumbers />} roles={["2"]} />,
      },
      {
        path: "voice-library",
        element: <PrivateRoute element={<VoiceLibrary />} roles={["2"]} />,
      },
      {
        path: "vapi-api-keys",
        element: <PrivateRoute element={<ApiKeys />} roles={["2"]} />,
      },
      {
        path: "vapi-workflows",
        element: <PrivateRoute element={<Workflows />} roles={["2"]} />,
      },
      {
        path: "vapi-outbound-calls",
        element: <PrivateRoute element={<OutboundCalls />} roles={["2"]} />,
      },
      {
        path: "vapi-files",
        element: <PrivateRoute element={<Files />} roles={["2"]} />,
      },
      {
        path: "vapi-integrations",
        element: <PrivateRoute element={<Integrations />} roles={["2"]} />,
      },
      {
        path: "vapi-logs",
        element: <PrivateRoute element={<Logs />} roles={["2"]} />,
      },
      {
        path: "vapi-billing",
        element: <PrivateRoute element={<Billing />} roles={["2"]} />,
      },

       // Admin pages routes
   {
    path: "/llm-configs",
    element: <LLMConfigsList />,
  },

  {
    path: "/voice-configs",
    element: <VoiceConfigsList />,
  },
   {
    path: "/transcriber-configs",
    element: <TranscriberConfigsList />,
  },

    {
    path: "/analysis-configs",
    element: <AnalysisConfigsList />,
  },
  {
    path: "/tool-configs",
    element: <ToolsList />,
  },

  
 {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/payment-history",
    element: <PaymentHistory />,
  },
  {
    path: "/admin-settings",
    element: <AdminSettings />,
  },

    ],
  },
  {
    path: "profile-page",
    element: <ProfilePage />,
  },
  {
    path: "/sign-in",
    element: <LoginScreen />,
  },
  {
    path: "/try-out",
    element: <TryoutScreen />,
  },
  {
    path: "/sign-up",
    element: <SignupScreen />,
  },
  {
    path: "/invite/:id",
    element: <LoginScreen />,
  },
  {
    path: "/add-company/:id",
    element: <LoginScreen />,
  },
  {
    path: "unauthorized",
    element: <UnauthorizedPage />,
  },
  {
    path: "/discover",
    element: <Landing />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/contact",
    element: <ContactUs />,
  },
  {
    path: "/loginScreen",
    element: <LoginScreen />,
  },
  {
    path: "/call-screen",
    element: <CallScreen />,
  },

 
]);

function App() {
  return (
    <>
      <Toaster toastOptions={ToastTheme} />
      <RouterProvider router={routes} />
      <ModalManager />
    </>
  );
}

export default App;
